import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Grid } from '@alfa-bank/site-grid-universal';
import { ProfitabilityRenderer } from '@alfa-bank/site-invest-ui/components/renderer';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';

import { ProfitabilityCell as Component } from './component';
import type { IDepsMobile, TProfitabilityCellMobile } from './models';
import styles from './styles.css';

export const ProfitabilityCellMobile = createWidget<IDepsMobile, TProfitabilityCellMobile>({
    Grid,
    ProfitabilityRenderer,
    Text,
    styles,
})(Component);
